import React, { useState, useEffect } from 'react';

import { Dropdown } from 'react-bootstrap';
import '../JobStageSummary.scss';
import { blockInvalidChar } from '../../../_common/blockInvalidChar';
import {
    GetStageSheet_getStageSheet_details as StageSheet,
    GetStageInfo_getStageInfo as Stages,
    GetPartials_getPartials as Partials,
} from '../../../../types/schemaTypes';

interface PartialBoxProps {
    index: number;
    stageSheetBoxId: number;
    proppantId: number;
    boxDesc: string;
    splitWeight: number;
    stageSheetId: number;
}

interface StageSheetPartialModalRowProps {
    index: number;
    jobId: number;
    stageSheetId: number;
    boxCount: number;
    box?: Partials;
    setBoxCount: React.Dispatch<React.SetStateAction<number>>;
    stageSheet: StageSheet | undefined;
    stages: Stages[];
    boxList: PartialBoxProps[] | undefined;
    setBoxList: React.Dispatch<React.SetStateAction<PartialBoxProps[] | undefined>>;
    showDelete: boolean;
    weightNotAnIntegerError: number[] | undefined;
    setWeightNotAnIntegerError: React.Dispatch<React.SetStateAction<number[] | undefined>>;
    weightOutOfBoundsError: number[] | undefined;
    setWeightOutOfBoundsError: React.Dispatch<React.SetStateAction<number[] | undefined>>;
    stageError: number[] | undefined;
    setStageError: React.Dispatch<React.SetStateAction<number[] | undefined>>;
    duplicateError: number[] | undefined;
    setDuplicateError: React.Dispatch<React.SetStateAction<number[] | undefined>>;
}

const StageSheetPartialModalRow = ({
    index,
    jobId,
    stageSheetId,
    box,
    boxCount,
    setBoxCount,
    stageSheet,
    stages,
    boxList,
    setBoxList,
    showDelete,
    weightNotAnIntegerError,
    setWeightNotAnIntegerError,
    weightOutOfBoundsError,
    setWeightOutOfBoundsError,
    stageError,
    setStageError,
    duplicateError,
    setDuplicateError,
}: StageSheetPartialModalRowProps): React.ReactElement => {
    const [splitWeight, setSplitWeight] = useState(box && box.splitWeight ? box.splitWeight : -1);
    const [stage, setStage] = useState('');
    const [stageColor, setStageColor] = useState('');
    const [isDeleted, setIsDeleted] = useState(false);

    const partialBox: PartialBoxProps = {
        index: index,
        stageSheetBoxId: box?.stageSheetBoxId ?? -1,
        proppantId: stageSheet?.proppantId ?? -1,
        boxDesc: stageSheet?.boxDesc ?? '',
        splitWeight: box?.splitWeight ?? -1,
        stageSheetId: box?.stageSheetId ?? -1,
    };

    if (!boxList && index === 0) {
        setBoxList([partialBox]);
    }

    if (box) {
        stages.map(stageItem => {
            if (stageItem.stageSheetId === box.stageSheetId && stage === '' && stageItem.stageDesc)
                setStage(stageItem.stageDesc);
            if (stageItem.stageSheetId === box.stageSheetId && stage === '' && stageItem.stageSheetColor)
                setStageColor(stageItem.stageSheetColor);
        });
    }

    useEffect(() => {
        if (!boxList) {
            const temp = [partialBox];
            setBoxList(temp);
        } else {
            const temp = boxList;
            temp.push(partialBox);
            setBoxList(temp);
        }
    }, []);

    stages = stages.filter(stage => {
        if (stage && stage.stageSheetId !== stageSheetId) return stage;
    });

    const errorMessage = {
        weightNotAnIntegerErrorMessage: 'Enter a valid weight',
        weightOutOfBoundsErrorMessage: 'Weight must not be more than ',
        stageErrorMessage: 'Select a Stage',
        duplicateErrorMessage: 'Stage must be unique',
    };

    const handleOnChangeWeight = weight => {
        if (Number.isNaN(weight) || !Number.isInteger(weight) || weight < 1) weight = -1;
        setSplitWeight(weight);

        const tempBoxList = boxList;
        tempBoxList?.map(boxItem => {
            if (boxItem.index === index && boxItem) {
                boxItem.splitWeight = weight;
            }
        });
        setBoxList(tempBoxList);

        if (weightNotAnIntegerError?.includes(index)) {
            weightNotAnIntegerError.splice(weightNotAnIntegerError.indexOf(index), 1);
            setWeightNotAnIntegerError(weightNotAnIntegerError);
        }
    };

    const handleOnChangeStage = (stage, stageId, stageColor) => {
        setStage(stage);
        setStageColor(stageColor);

        const tempBoxList = boxList;
        tempBoxList?.map(boxItem => {
            if (boxItem.index === index && boxItem) {
                boxItem.stageSheetId = stageId;
            }
        });
        setBoxList(tempBoxList);

        if (stageError?.includes(index)) {
            stageError.splice(stageError.indexOf(index), 1);
            setStageError(stageError);
        }

        if (duplicateError?.includes(index)) {
            duplicateError.splice(duplicateError.indexOf(index), 1);
            setDuplicateError(duplicateError);
        }
    };

    // const handleOnChangestage = (stage, maxStage) => {
    //     if (Number.isNaN(stage) || !Number.isInteger(stage) || stage === 0) stage = -1;
    //     setStage(stage);

    //     let tempStagesToAdd = stagesToAdd;
    //     tempStagesToAdd?.map(stage => {
    //         if (stage.index === index && stage) {
    //             stage.stageNum = stage;
    //             stage.maxStageNum = maxStage;
    //         }
    //     });
    //     setStagesToAdd(tempStagesToAdd);

    //     if (stageNotAnIntegerError?.includes(index)) {
    //         stageNotAnIntegerError.splice(stageNotAnIntegerError.indexOf(index), 1);
    //         setStageNotAnIntegerError(stageNotAnIntegerError);
    //     }
    //     if (stageOutOfBoundsError?.includes(index)) {
    //         stageOutOfBoundsError.splice(stageOutOfBoundsError.indexOf(index), 1);
    //         setStageOutOfBoundsError(stageOutOfBoundsError);
    //     }
    //     if (stageMaxError?.includes(index)) {
    //         stageMaxError.splice(stageMaxError.indexOf(index), 1);
    //         setStageMaxError(stageMaxError);
    //     }
    //     if (stageDuplicateError?.includes(index)) {
    //         stageDuplicateError.splice(stageDuplicateError.indexOf(index), 1);
    //         setStageDuplicateError(stageDuplicateError);
    //     }
    //     if (duplicateError?.includes(index)) {
    //         duplicateError.splice(duplicateError.indexOf(index), 1);
    //         setDuplicateError(duplicateError);
    //     }
    //     if (runsheetDuplicateError?.includes(index)) {
    //         runsheetDuplicateError.splice(runsheetDuplicateError.indexOf(index), 1);
    //         setRunsheetDuplicateError(runsheetDuplicateError);
    //     }
    // };

    // const getStageCount = () => {
    //     for (let box of boxs) {
    //         if (box && box.box === box) return box.stages;
    //     }
    // };

    const handleOnDelete = () => {
        setIsDeleted(true);

        setBoxCount(boxCount - 1);

        let tempBoxList = boxList;
        tempBoxList = tempBoxList?.filter(box => {
            if (box.index !== index) return box;
        });
        setBoxList(tempBoxList);
    };

    if (isDeleted) {
        return <></>;
    }

    return (
        <tr>
            <td className="AddStageModal-Column">
                <Dropdown>
                    <Dropdown.Toggle
                        variant="outline-dark"
                        id="dropdown-basic"
                        className="AddStageModal-Dropdown"
                        disabled={!showDelete}
                    >
                        <div className="StageSheetBox" style={{ backgroundColor: `${stageColor}` }}></div>{' '}
                        <span>{stage.length === 0 ? 'Select Stage' : stage}</span>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        {stages.map((stage, index) => (
                            <Dropdown.Item
                                className="StageSheetBox-Item"
                                key={index}
                                // onSelect={() =>
                                //     handleOnChangeStage(stage.stageDesc, stage.stageSheetId, stage.stageSheetColor)
                                // }
                                onClick={() =>
                                    handleOnChangeStage(stage.stageDesc, stage.stageSheetId, stage.stageSheetColor)
                                }
                            >
                                <div
                                    className="StageSheetBox"
                                    style={{ backgroundColor: `${stage.stageSheetColor}` }}
                                ></div>{' '}
                                &nbsp;{stage.stageDesc}
                            </Dropdown.Item>
                        ))}
                    </Dropdown.Menu>
                </Dropdown>

                <div className="AddStageModal-Error">
                    {stageError?.includes(index) && errorMessage.stageErrorMessage}
                </div>
                <div className="AddStageModal-Error">
                    {duplicateError?.includes(index) && errorMessage.duplicateErrorMessage}
                </div>
            </td>

            <td className="AddStageModal-Column AddStageNumber-Container">
                <input
                    type="number"
                    className="AddStageNumber"
                    onKeyDown={blockInvalidChar}
                    value={splitWeight === -1 ? '' : splitWeight}
                    onChange={element => handleOnChangeWeight(parseInt(element.target.value))}
                />
                <div className="AddStageModal-Error">
                    {weightNotAnIntegerError?.includes(index) && errorMessage.weightNotAnIntegerErrorMessage}
                </div>
                <div className="AddStageModal-Error">
                    {weightOutOfBoundsError?.includes(index) && errorMessage.weightOutOfBoundsErrorMessage}
                </div>
            </td>

            <td className="AddStageModal-Column">
                {showDelete && (
                    <div className="AddStage-Delete-Container">
                        <i className="material-icons AddStage-Delete-Button" onClick={() => handleOnDelete()}>
                            cancel
                        </i>
                    </div>
                )}
            </td>
        </tr>
    );
};

export default StageSheetPartialModalRow;
